import React from "react";
import { Table } from "../../../components/CustomPaginations";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { tableStyle } from "../../ticketModule/variables/ListingVariables";

const ReimbursementPolicyTable = (props) => {
  const {
    pagerData,
    tableData,
    numberOfItemsPerPage,
    pageNum,
    getColumns,
    defaultSorted,
    isLoading,
    handleTableChange,
    receiveData,
    tableLoader,
  } = props;

  return (
    <div className="mt-4 pt-4">
      <PaginationProvider
        pagination={paginationFactory({
          custom: true,
          totalSize: pagerData ? pagerData.TotalCount : 0,
          page: pageNum,
          sizePerPage: numberOfItemsPerPage,
          paginationSize: numberOfItemsPerPage,
        })}
      >
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Table
              inputValue={""}
              keyField={"policyID"}
              columns={getColumns}
              items={tableData}
              tableStyle={tableStyle}
              paginationProps={paginationProps}
              paginationTableProps={paginationTableProps}
              onTablePageChange={handleTableChange}
              defaultSorted={defaultSorted}
              showFeedback={false}
              tableLoader={tableLoader}
              SearchBar={() => {
                return null;
              }}
              pagerData={pagerData}
              receiveData={(PageSize) => {
                receiveData(PageSize);
              }}
            />
          );
        }}
      </PaginationProvider>
    </div>
  );
};

export default ReimbursementPolicyTable;
